import React from "react";
import "./styles/Rythm.css";
function Rythm() {
  return (
    <div className="f--container">
      <h6 className="f--title">Rythm/Ritmi</h6>
      <div className="f--item">
        <button>1/2</button>
        <button>3/4</button>
        <button>4/4</button>
        <button>6/8</button>
      </div>
    </div>
  );
}

export default Rythm;
